import { render, staticRenderFns } from "./ThingEditing.vue?vue&type=template&id=b3875436"
import script from "./ThingEditing.vue?vue&type=script&lang=js"
export * from "./ThingEditing.vue?vue&type=script&lang=js"
import style0 from "./ThingEditing.vue?vue&type=style&index=0&id=b3875436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports